import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { Sparkles } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const SmartTransformNode = ({ data, selected }: NodeProps) => {
    return (
        <BaseNodeUI
            title="AI Logic"
            icon={Sparkles}
            colorClass="text-purple-600"
            bgClass="bg-purple-100"
            selected={selected}
            isRunning={data?.executionStatus === 'Running'} executionStatus={data?.executionStatus}
            rowsProcessed={data?.rowsAffected}
        />
    );
};

export default memo(SmartTransformNode);
